'use client'

import React, { FC, useCallback } from 'react'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { Search, X } from 'lucide-react'
import { cn } from '@/lib/utils'

interface BitmapSearchProps {
	value: string
	onChange: (value: string) => void
	onSearch: (value: string) => void
	onClear: () => void
	className?: string
}

const BitmapSearch: FC<BitmapSearchProps> = ({
	value,
	onChange,
	onSearch,
	onClear,
	className
}) => {
	const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		onChange(e.target.value)
	}, [onChange])

	const handleSearch = useCallback(() => {
		if (value.trim()) {
			onSearch(value.trim())
		}
	}, [value, onSearch])

	const handleKeyDown = useCallback(
		(e: React.KeyboardEvent<HTMLInputElement>) => {
			if (e.key === 'Enter') {
				handleSearch()
			}
		},
		[handleSearch]
	)

	const handleClear = useCallback(() => {
		onClear()
	}, [onClear])

	return (
		<div className={cn('relative', className)}>
			<Search className="absolute left-2 sm:left-3 top-1/2 -translate-y-1/2 size-3 sm:size-4 text-muted-foreground" />
			<Input
				type="text"
				value={value}
				onChange={handleInputChange}
				onKeyDown={handleKeyDown}
				placeholder="Search block height, name, or attributes..."
				className="h-7 sm:h-10 text-xs sm:text-sm pl-7 sm:pl-9 pr-8 sm:pr-10"
			/>
			{value && (
				<Button
					variant="ghost"
					size="icon"
					className="absolute right-1 top-1/2 -translate-y-1/2 size-5 sm:size-6"
					onClick={handleClear}
				>
					<X className="size-3" />
				</Button>
			)}
		</div>
	)
}

export default BitmapSearch

